import React from 'react'
import { authRoles } from '../../auth/authRoles'

const PublicRoute = [

    {
        path: '/publicPage',
        component: React.lazy(() => import('./PublicPage')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/home',
        component: React.lazy(() => import('./../HotelRegistration/Home_page_agoda')),  // need to replace Home_page, here Home_page_agoda mean new home page using agoda
    },

    {
        path: '/about',
        component: React.lazy(() => import('./../HotelRegistration/AboutUs')),

    },
    {
        path: '/PrivacyPolicy',
        component: React.lazy(() => import('./../HotelRegistration/PrivacyPolicy')),

    },
    {
        path: '/TermsOfUse',
        component: React.lazy(() => import('./../HotelRegistration/TermsOfUse')),

    },
    {
        path: '/faq',
        component: React.lazy(() => import('./../HotelRegistration/FAQ')),

    },
    {
        path: '/contact',
        component: React.lazy(() => import('./../HotelRegistration/Contact')),

    },

    {
        path: '/singlehotel/:id',
        component: React.lazy(() => import('./../HotelRegistration/SingleHotelMain')),

    },

    {
        path: '/bookingView',
        component: React.lazy(() => import('./../HotelRegistration/HotelBookingMainView')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/bookingConfirm/:id',
        component: React.lazy(() => import('./../HotelRegistration/BookingConfirm')),
        //auth: authRoles.dashboard,
    },






   

    {
        path: '/hotellist',
        component: React.lazy(() => import('../HotelRegistration/HotelList_Agoda')),  // need to replace HotelList, here  HotelList_agoda mean new search page using agoda
        //auth: authRoles.dashboard,
    },

    {
        path: '/hoteltable',
        component: React.lazy(() => import('./../HotelRegistration/HotelTable')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/hotellistview',
        component: React.lazy(() => import('./../HotelRegistration/HotelListView')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/hotelregistration',
        component: React.lazy(() => import('./../HotelRegistration/HotelRegistration')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/hotelrooms/:id',
        component: React.lazy(() => import('./../HotelRegistration/HotelRooms')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/singlehotelview/:id',
        component: React.lazy(() => import('./../HotelRegistration/SingleHotelView')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/ownerdashboard',
        component: React.lazy(() => import('./../HotelRegistration/OwnerDashboard')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/hotelroomSingle/:id',
        component: React.lazy(() => import('./../HotelRegistration/HotelRoomSingle')),
        //auth: authRoles.dashboard,
    },


    // Owner Registration
    {
        path: '/hotel_registration',
        component: React.lazy(() => import('../Hotel_Owner/Registration/Setup')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/registerHotel',
        component: React.lazy(() => import('../Hotel_Owner/Registration/RegisterHotel')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/addAddress',
        component: React.lazy(() => import('../Hotel_Owner/Registration/AddAddress')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/addPropertyServices',
        component: React.lazy(() => import('../Hotel_Owner/Registration/PropertyServices')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/myWellnessPackages',
        component: React.lazy(() => import('../Hotel_Owner/Registration/WellnessPackege')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/editWellnessPackages/:id',
        component: React.lazy(() => import('../Hotel_Owner/Registration/editWellnessPackege')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/addCustomWellnessPackages',
        component: React.lazy(() => import('../Hotel_Owner/Registration/customeWellnessPackege')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/setCheckinCheckout',
        component: React.lazy(() => import('../Hotel_Owner/Registration/ChekingCheckout')),
        auth: authRoles.hotel_owner,
    },


    // Owner Hotel Setup
    {
        path: '/main_setup_view/:id',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/Setup')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/room_details_setup',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/RoomDetails')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/room_price_and_rates/:id',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/PriceAndRates')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/room_price_and_rates_all_view',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/PriceAndRatesAllView')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/new_cancellation_policy',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/NewCancellationPolicy')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/edit_cancellation_policy/:id',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/EditCancellationPolicy')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/upload_Photo_and_video',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/UploadPropertyPhoto')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/payment_configuration',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/payment_config')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/reauth',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/Reauth')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/unavailable_date/:id',
        component: React.lazy(() => import('../Hotel_Owner/SetupViews/UnavailableDate')),
        auth: authRoles.hotel_owner,
    },


]

export default PublicRoute
